var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-machines-list-wrapper"},[(_vm.$slots.title)?_c('div',{staticClass:"my-machines-list-wrapper__title"},[_vm._t("title")],2):_vm._e(),_c('ul',{staticClass:"my-machines-list-wrapper__list"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }